import React from 'react';
import { makeStyles, Image, Text, tokens, typographyStyles } from '@fluentui/react-components';
import RestrictedPlaceholder from '../assets/restricted.svg';

const useStyles = makeStyles({
  errorPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noResultWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '100px',
  },
  noResultFirstRow: {
    marginTop: tokens.spacingVerticalXXL,
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase600,
    lineHeight: tokens.lineHeightHero700,
  },
  noResultSecondRow: {
    marginTop: tokens.spacingVerticalS,
    ...typographyStyles.body2,
  },
});

const FailToFetch = () => {
  const classes = useStyles();
  return (
    <div className={classes.errorPageContainer}>
      <div className={classes.noResultWrapper}>
        <Image src={RestrictedPlaceholder} height="200" width="222" />
        <Text className={classes.noResultFirstRow}>You may have an ad blocker which is preventing this page from loading correctly.</Text>
        <Text className={classes.noResultSecondRow}>Please disable your ad blocker to access the full content of this page.</Text>
      </div>
    </div>
  );
};

export const FailToFetchPage = FailToFetch;
